class NovaImageWithText extends HTMLElement {
  constructor() {
    super()

    this.videoBox = this.querySelector('.image-with-text__video')
  }

  connectedCallback() {
    window.addEventListener('resize', this.doAspectRation.bind(this))
    this.doAspectRation()
  }

  doAspectRation() {
    if (!this.videoBox) return false
    
    const videoBoxRatio = this.videoBox.offsetWidth / 520
    const aspectRatio = Number(this.videoBox.dataset.ratio)
    const clsName = 'image-with-text__video-fit-w'
    if (videoBoxRatio >= aspectRatio) {
      this.videoBox.classList.add(clsName)
    } else {
      this.videoBox.classList.remove(clsName)
    }
  }
}

customElements.define('nova-image-with-text', NovaImageWithText)
